import React from 'react';
import styled, { css } from 'styled-components/macro';
import constantes from '../resources/constantes.json';
import Shape from '../assets/img/Shape.png';

const Logo = ({ codpar, ambito, width, height, ...rest }) => {
  const basename = `${constantes.rutas.logo}${codpar.padStart(4, '0')}`;

  return (
     <ContenedorLogos width={width} height={height}>
      {/* <Fallback width={width} height={height}/> */}
      <LogoImg
        src={`${basename}.png`}
        alt=""
        {...rest}
      />
    </ContenedorLogos>
  );
};
export default Logo;

const ContenedorLogos = styled.div`
  width: ${({ width }) => (width!==undefined?width:'60px')};
  height: ${({ height }) => (height!==undefined?height:'60px')};
  position: relative;
  display: inline-block;
  display:flex;
  align-items: center;
	justify-content:center;
	display:flex;
`;

const LogoImg = styled.img`
  position: absolute;
`;

const Fallback = styled.div`
  position: absolute;
  background: transparent;
  width: ${({ width }) => (width!==undefined?width:'60px')};
  height: ${({ height }) => (height!==undefined?height:'60px')};
`;
